import moment from 'moment-timezone';
import React from 'react'
import formatDateTimeByTimezone from 'hooks/formatDateTimeByTimezone';
const InterviewInviteTable = ({
    InterviewInvite,

}) => {


    const facilityName = React.useMemo(() => {
        if (InterviewInvite?.appointment_details?.facility?.facility_name) {
            return `${InterviewInvite?.appointment_details?.facility?.facility_name} ${InterviewInvite?.appointment_details?.address ? ", " + InterviewInvite?.appointment_details?.address : ""}`
        }
        else {
            return InterviewInvite?.appointment_details?.address || "N/A"
        }

    }, [InterviewInvite?.appointment_details?.facility?.facility_name, InterviewInvite?.appointment_details?.address])


    const departmentName = React.useMemo(() => {
        if (InterviewInvite?.appointment_details?.department?.department_name) {
            return `${InterviewInvite?.appointment_details?.department?.department_name} ${InterviewInvite?.appointment_details?.department_text ? ", " + InterviewInvite?.appointment_details?.department_text : ""}`
        }
        else {
            return InterviewInvite?.appointment_details?.department_text || "N/A"
        }

    }, [InterviewInvite?.appointment_details?.department?.department_name, InterviewInvite?.appointment_details?.department_text])



    const dynamicFields = React.useMemo(() => {
        const dynamic_fields = InterviewInvite.appointment_details?.dynamic_fields && JSON.parse(InterviewInvite.appointment_details?.dynamic_fields) || []
        const dynamicFields = dynamic_fields?.map(field => ({ name: field?.name, value: field?.value }));
        return dynamicFields || [];
    }, [InterviewInvite.appointment_details?.dynamic_fields])

    const renderTableItem = (title, text,) => (
        <>
            <td className='bg-primary-secondary'>
                <h4>{title}</h4>
            </td>
            <td className='bg-primary-secondary'>{text || 'N/A'}</td>
        </>

    )



    const formattedDate = moment(InterviewInvite?.datetime, 'YYYY-MM-DD HH:mm:ss').format('MMM D, YYYY HH:mm');

    const ClientTimezone = InterviewInvite?.invite_details?.interpreter?.timezone;
    const rawDatetime = InterviewInvite?.datetime;
    const formattedClientTime = formatDateTimeByTimezone(rawDatetime, ClientTimezone, 'datetime');
    const workOrder = InterviewInvite?.appointment_interpreter_work_order;

    return (
        <div className="appointment-details">
            <div className="details_row">
                <h2>Type:</h2>
                <h3>{InterviewInvite?.type || 'N/A'}</h3>
            </div>

            <div className="details_row">
                <h2>Language:</h2>
                <h3>{InterviewInvite?.language?.name || 'N/A'}</h3>
            </div>
            <div className="details_row">
                <h2>Date/Time:</h2>
                <h3>{formattedClientTime || 'N/A'}</h3>
            </div>

            <div className="details_row">
                <h2>Client:</h2>
                <h3>{InterviewInvite?.subclient ? InterviewInvite?.subclient?.subaccount_name : InterviewInvite?.accounts?.user?.name || 'N/A'}</h3>

            </div>
            <div className="details_row">
                <h2>Facility:</h2>
                <h3>{facilityName}</h3>
            </div>
            <div className="details_row">
                <h2>Department:</h2>
                <h3>{departmentName || 'N/A'}</h3>
            </div>

            <div className="details_row">
                <h2>Requester Name:</h2>
                <h3>{InterviewInvite?.appointment_details?.requester_name || 'N/A'}</h3>
            </div>
            <div className="details_row">
                <h2>Requester Email:</h2>
                <h3>{InterviewInvite?.appointment_details?.requester_email || 'N/A'}</h3>
            </div>
            <div className="details_row">
                <h2>Requester Phone:</h2>
                <h3>{InterviewInvite?.appointment_details?.requester_phone || 'N/A'}</h3>
            </div>

            <div className="details_row">
                <h2>Start Time:</h2>
               <h3>{InterviewInvite?.start_time ? moment(InterviewInvite.start_time, "HH:mm").format("hh:mm A") : 'N/A'}</h3>

            </div>
            <div className="details_row">
                <h2>Estimated Duration:</h2>
                <h3>{InterviewInvite?.estimated_duration + " " + InterviewInvite?.estimated_duration_unit || 'N/A'}</h3>
            </div>

            <div className="details_row">
                <h2>Gender:</h2>
                <h3>{InterviewInvite?.appointment_details?.interpreter_gender || 'N/A'}</h3>
            </div>

            {InterviewInvite?.appointment_details?.video_link && <div className="details_row">
                <h2>Video link:</h2>
                <h3>{InterviewInvite?.appointment_details?.video_link || 'N/A'}</h3>
            </div>}

            {dynamicFields.length > 0 && dynamicFields[0]?.name !== null && (
                <>
                    {dynamicFields.map((field, index) => (
                        <div className="details_row" key={index}>
                            <h2>Dynamic Field {index + 1}:</h2>
                            <h3>{`${field.name}: ${field.value}`}</h3>
                        </div>
                    ))}
                </>
            )}


            {workOrder && <WorkOrderSummary workOrder={workOrder} />}
        </div>
    )
}




const WorkOrderSummary = ({ workOrder }) => (
    <div className="Table_data_show Table_data_show1 p-0">

        <div className="details_row">
            <h2>Custom Work Order Summary:</h2>
        </div>


        <table className=" table">
            <tbody>
                <tr>
                    <td className="">Mileage (km):</td>
                    <td className="">{workOrder.mileage ?? "0"}</td>
                    <td className="">Mileage Rate:</td>
                    <td className="">${Number(workOrder.mileage_rate ?? 0).toFixed(2)}</td>
                    <td className="">Mileage Total:</td>
                    <td className="">${Number(workOrder.mileage_total ?? 0).toFixed(2)}</td>
                </tr>
                <tr>
                    <td className="">Travel Hours:</td>
                    <td className="">{workOrder.travel_hours ?? "0"}</td>
                    <td className="">Travel Rate:</td>
                    <td className="">${Number(workOrder.travel_rate ?? 0).toFixed(2)}</td>
                    <td className="">Travel Total:</td>
                    <td className="">${Number(workOrder.travel_total ?? 0).toFixed(2)}</td>
                </tr>
                <tr>
                    <td className="">Min Duration (hrs):</td>
                    <td className="">{workOrder.min_duration ?? "0"}</td>
                    <td className="">Rate per hr:</td>
                    <td className="">${Number(workOrder.duration_rate ?? 0).toFixed(2)}</td>
                    <td className="">Session Total:</td>
                    <td className="">${Number(workOrder.session_total ?? 0).toFixed(2)}</td>
                </tr>

                <tr>
                    <td className="" colSpan={5} style={{ textAlign: "right", fontWeight: "bold" }}> Total:</td>
                    <td className="">${Number(workOrder.total ?? 0).toFixed(2)}</td>
                </tr>
            </tbody>
        </table>
    </div>
);

export default InterviewInviteTable